/**
 * @generated SignedSource<<d268709b9a838e67a9312ecd9cd2be6e>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RemoveAnthropicIntegrationInput = {
  orgId: string;
};
export type RemoveAnthropicIntegrationMutation$variables = {
  input: RemoveAnthropicIntegrationInput;
};
export type RemoveAnthropicIntegrationMutation$data = {
  readonly removeAnthropicIntegration: {
    readonly problems: ReadonlyArray<{
      readonly message: string;
    }>;
  };
};
export type RemoveAnthropicIntegrationMutation = {
  response: RemoveAnthropicIntegrationMutation$data;
  variables: RemoveAnthropicIntegrationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RemoveAnthropicIntegrationMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "RemoveAnthropicIntegrationPayload",
        "kind": "LinkedField",
        "name": "removeAnthropicIntegration",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "problems",
            "plural": true,
            "selections": [
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "RemoveAnthropicIntegrationMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "RemoveAnthropicIntegrationPayload",
        "kind": "LinkedField",
        "name": "removeAnthropicIntegration",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "problems",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1c665c0c58fd53ed0c5a9d888b8cce2c",
    "id": null,
    "metadata": {},
    "name": "RemoveAnthropicIntegrationMutation",
    "operationKind": "mutation",
    "text": "mutation RemoveAnthropicIntegrationMutation(\n  $input: RemoveAnthropicIntegrationInput!\n) {\n  removeAnthropicIntegration(input: $input) {\n    problems {\n      __typename\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3952a2b44b3753ce7b1c04ca344db579";

export default node;
